export enum FlexTypes {
  CompleteAutonomy = 1,
  RequiresAuthCode = 2,
  NotAllowed = 3
}
